import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import { Getstarted } from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBoxTechno } from '../techno.component';
import phoneImg from '../../../assest/phoneImg/Zero Knowledge Proof.png';
import './zero-proofs.styles.scss';

export const ZeroProofs = () => {
  const { t } = useTranslation('zkp');
  const paragraphs = t('paragraphs', { returnObjects: true });

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('pageTitle')} uris={t('pageUri')} />
      <OverlapBoxTechno img={phoneImg} title={t('sectionTitle')}>
        {paragraphs.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
      </OverlapBoxTechno>
      <Getstarted />
      <Footer />
    </div>
  );
};

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-kp'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
          Platform / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};
